<div id="error-container" class="container">
  <mat-card appearance="outlined">
    <mat-card-title>Sorry, our site does not support Safari private browsing.</mat-card-title>
    <mat-card-content>
      <p>Safari private browsing disables technologies simplebills.com requires to function.</p>
      <p>Please access our site with standard Safari or try Chrome/Firefox private browsing.</p>
    </mat-card-content>
  </mat-card>
</div>